import React from "react";
import { Trash2, Lightbulb, Info, Utensils, Car, Sparkles, AlertTriangle, EyeOff, Eye } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { NOTE_ICONS, noteIsInternal } from "@/pages/cotizador/shared";

// Mapa icono → componente lucide (compartido con el visor público).
export const NOTE_ICON_COMP = {
  suggestion: Lightbulb,
  city_info: Info,
  restaurant: Utensils,
  driving: Car,
  tip: Sparkles,
  warning: AlertTriangle,
  info: Info,
};

export function CotNoteRow({ note, onChange, onRemove, tid }) {
  const Icon = NOTE_ICON_COMP[note.icon] || Lightbulb;
  const internal = noteIsInternal(note);
  return (
    <div className={`rounded-md border p-2.5 ${internal ? "border-slate-300 bg-slate-100/70" : "border-amber-200/70 bg-amber-50/50"}`} data-testid={tid}>
      <div className="flex items-center gap-2">
        <Icon className={`h-4 w-4 shrink-0 ${internal ? "text-slate-500" : "text-amber-600"}`} />
        <select
          value={internal ? "internal" : "client"}
          onChange={(e) => onChange({ visibility: e.target.value })}
          className={`h-7 rounded-md border px-1.5 text-xs font-medium outline-none focus:ring-1 focus:ring-ring ${internal ? "border-slate-400 bg-slate-200 text-slate-800" : "border-emerald-300 bg-emerald-50 text-emerald-800"}`}
          title="«Para el cliente» se publica en la web y el PDF. «Interna» solo se ve aquí."
          data-testid={`${tid}-visibility`}
        >
          <option value="client">Para el cliente</option>
          <option value="internal">Interna</option>
        </select>
        <select
          value={note.icon || "suggestion"}
          onChange={(e) => onChange({ icon: e.target.value })}
          className="h-7 rounded-md border bg-background px-1.5 text-xs outline-none focus:ring-1 focus:ring-ring"
          data-testid={`${tid}-icon`}
        >
          {NOTE_ICONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <Input
          value={note.title || ""} onChange={(e) => onChange({ title: e.target.value })}
          placeholder="Título (opcional)" className="h-7 flex-1 text-xs" data-testid={`${tid}-title`}
        />
        {internal ? (
          <span className="inline-flex shrink-0 items-center gap-1 rounded bg-slate-700 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-white" data-testid={`${tid}-internal-badge`}><EyeOff className="h-3 w-3" /> Interna · no visible para el cliente</span>
        ) : (
          <span className="inline-flex shrink-0 items-center gap-1 rounded bg-emerald-600 px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide text-white" data-testid={`${tid}-client-badge`}><Eye className="h-3 w-3" /> Visible en web y PDF</span>
        )}
        <Button size="icon" variant="ghost" className="h-7 w-7 text-destructive" onClick={onRemove} aria-label="Eliminar nota" data-testid={`${tid}-remove`}>
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
      <Textarea
        rows={2} value={note.text || ""} onChange={(e) => onChange({ text: e.target.value })}
        placeholder={internal ? "Nota interna del equipo (no se publica): REPEAT, cumpleaños, avisos…" : "Texto que verá el cliente (sugerencia, info de ciudad, restaurantes, conducción…)"}
        className="mt-2 text-xs" data-testid={`${tid}-text`}
      />
      <Input
        value={(note.images || []).join(", ")}
        onChange={(e) => onChange({ images: e.target.value.split(",").map((s) => s.trim()).filter(Boolean) })}
        placeholder="Imágenes (URLs separadas por coma, opcional)"
        className="mt-1.5 h-7 text-[11px]" data-testid={`${tid}-images`}
      />
    </div>
  );
}
